import React, { useState } from 'react'
import { MdArrowBackIosNew } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import HeroImg from '../../Shared components/HeroImg';
import OtpInput from 'react-otp-input';
import toast from 'react-hot-toast';
import axios from 'axios';
import { Config } from '../../API/config';
import BeatLoader from 'react-spinners/esm/BeatLoader';

const ResetPasswordCode = () => {
    let email = useParams().email || ""
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [Loading, setLoading] = React.useState<boolean>(false)



    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (otp.length !== 6) {
            toast.error("يرجى إدخال رمز مكون من 6 أرقام");
            return;
        }
        try {
            setLoading(true);




            const data = await axios.post(
                Config.verifyOTP,
                { email, code: otp },
                { withCredentials: true }
            );

            if (data.data.statusCode == 201) {
                toast.success("تم التحقق من الرمز بنجاح");
                navigate(`/reset/${email}`); // Navigate to reset password page
            } else {
                toast.error(data.data.message || "حدث خطأ أثناء التحقق");
            }
        } catch (error) {
            toast.error("رمز غير صحيح، حاول مرة أخرى");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div>
                <div className="flex flex-row min-h-screen w-full">
                    <HeroImg />
                    <div className="flex flex-col items-end justify-start w-full mt-10 px-24 relative">
                        <button onClick={() => navigate(-1)}>
                            <div className='w-[40px] h-[40px] border absolute top-0 left-0 cursor-pointer ml-6 border-neutral-800 rounded-full flex justify-center items-center hover:bg-primary-100 transition-all duration-150 group'>
                                <MdArrowBackIosNew
                                    size={22}
                                    color='#4a4a4a'
                                    fontWeight={200}
                                    className="text-neutral-900 group-hover:translate-x-[-2px] group-hover:fill-white transition-transform duration-150"
                                />
                            </div>
                        </button>
                        <div className='w-full'>
                            <div className="w-full flex justify-end">
                                <h2 className="text-[32px] leading-[67.58px] font-[500] text-neutral-900"> Otlob Coach مرحباً بكم في </h2>
                            </div>
                            <div className="w-full flex justify-end">
                                <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">اعادة تعيين كلمة السر</p>
                            </div>
                            <div className='w-full my-3 '>
                                <form action="">
                                    <div className='w-full my-5 flex flex-row items-center justify-center '>
                                        <OtpInput
                                            value={otp}
                                            onChange={setOtp}
                                            numInputs={6}
                                            renderSeparator={<span>-</span>}
                                            inputStyle={{
                                                width: '50px',
                                                height: '50px',
                                                fontSize: '24px',
                                                margin: '0 10px',
                                                borderRadius: '10px',
                                                border: '1px solid #ccc'
                                            }}
                                            onPaste={(e) => e.clipboardData}
                                            inputType='number'

                                            renderInput={(props) => (
                                                <input
                                                    {...props}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className='w-full my-5 flex justify-center'>
                                        {
                                            Loading ?
                                                <BeatLoader className="mt-5" color="#072605" />
                                                :

                                                <button
                                                    className="bg-white text-primary-500 p-3 w-full mt-5 border rounded-md border-primary-500 md:w-[158px] hover:bg-primary-500 hover:text-white hover:border-transparent transition-all duration-500"
                                                    onClick={handleSubmit}
                                                >
                                                    استكمال
                                                </button>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div></div>
    )
}

export default ResetPasswordCode